<template>
  <b-modal
    centered
    scrollable
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    size="md"
    id="mc-modal-accept"
    :title="$t('deliveryRequest.modal.acceptDelivery.title')"
  >
    <div class="mc-modal-accept card-body">
      <p class="mc-modal-accept__text">
        <span v-html="$t('deliveryRequest.modal.acceptDelivery.message', { companyName })"></span>
      </p>
      <p>
        {{ $t('deliveryRequest.modal.acceptDelivery.description') }}
      </p>
      <FormulateForm @validation="handleValidation" v-model="formValues" name="accept-form">
        <FormulateInput
          v-for="field in acceptModalFields"
          :key="field.name"
          v-bind="field"
          :fullObject="fullObjects[field.name]"
          @update:fullObject="fullObjects[field.name] = $event"
        />
      </FormulateForm>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 gap-2">
        <McButton :disabled="isLoading" @click="cancel" variant="secondary" :text="$t('global.no')" />
        <McButton :disabled="isLoading" @click="handleSubmit" :text="$t('deliveryRequest.modal.acceptDelivery.confirm')" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'

import McButton from '@/components/McButton'
import acceptModalFields from '../lib/fields/accept-modal-fields'

export default {
  components: {
    McButton,
  },
  mixins: [acceptModalFields, Helper],
  inject: ['companyName', 'isBilledCustomerExists'],
  emits: ['transition'],
  data() {
    return {
      isLoading: false,
      fullObjects: {},
      formValues: {},
      errorObj: {},
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    hasTmsUserGroupAccess() {
      return (
        this.hasAccessAll([
          'tms-user-group:create',
          'tms-user-group:delete',
          'tms-user-group:read',
          'tms-user-group:update',
        ]) &&
        this.isSuperUser()
      )
    },
  },
  watch: {
    'formValues.user_group_id'(newVal, oldVal) {
      if (this.hasTmsUserGroupAccess && newVal !== oldVal && oldVal !== undefined) {
        this.formValues.marketing_user_id = null
        this.fullObjects.marketing_user_id = {}
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$formulate.submit('accept-form')

      if (this.errorObj.hasErrors) return

      this.isLoading = true

      const data = {
        status: 'ACCEPTED',
        fields: this.formValues,
      }

      if (this.hasTmsUserGroupAccess) {
        data.fields.user_group_id = Number(this.formValues.user_group_id)
      }

      this.$emit('transition', 'ACCEPT', data)
      this.isLoading = false
    },
    handleValidation(error) {
      this.errorObj = error
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-modal-accept {
  &__text {
    strong {
      font-weight: 600;
    }
  }
}
</style>
